/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Movement_Breakdown_Th_NameInputs */

const vi_movement_breakdown_th_name = /** @type {(inputs: Movement_Breakdown_Th_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên`)
};

/**

* @param {Movement_Breakdown_Th_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const movement_breakdown_th_name = /** @type {((inputs?: Movement_Breakdown_Th_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Movement_Breakdown_Th_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_movement_breakdown_th_name(inputs)
});